import React from "react"
import Image from "../image"
import Stores from "../stores"

class CaseIntroduction extends React.Component {
  render() {
    return (
      <div className="case-introduction">
        <div className="container">
          <div data-aos="fade-up" className="has-text-centered">
            <h2 className="title is-2">導入事例</h2>
          </div>
          <div>
            <div className="columns">
              <div data-aos="fade-up" className="column">
                <div className="box has-text-centered">
                  <div className="image">
                    <Image filename="restaurant/highfive.png" />
                  </div>
                  <div className="has-text-weight-semibold">
                    株式会社ハイファイブ 代表取締役 水野 裕嗣
                  </div>
                  <div className="text">
                    事前注文で会計も済ませられるPicksを導入したことでお昼のレジ待ちが緩和されました！また常連のお客様の満足度も上がっています。
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="column">
                <div className="box has-text-centered">
                  <div className="image">
                    <Image filename="restaurant/frijoles.png" />
                  </div>
                  <div className="has-text-weight-semibold">
                    株式会社フリホーレス 取締役副代表 高橋博久様
                  </div>
                  <div className="text">
                    Picks様のおかげで、急ぎで時間がないお客様にもご注文を頂けるようになりました！大変ありがたいです！！
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" className="column">
                <div className="box has-text-centered">
                  <div className="image">
                    <Image filename="restaurant/tacorico.png" />
                  </div>
                  <div className="has-text-weight-semibold">
                    株式会社ハピタ（タコリコ）代表 北島昇様
                  </div>
                  <div className="text">
                    Picksは並ばずに商品を手にできるので、人気があり、これからも需要は増えると思います。Picksとのコラボには大いに期待しています。
                  </div>
                </div>
              </div>
            </div>
            <div data-aos="fade-up">
              <Stores />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CaseIntroduction
